import {DEFAULT_VENUE_IMAGE} from '../../utils/remote-content'
import {Venue} from './types'

// The venue document comes back raw, so a venue without a logo has `logo: null` (or no logo, or one
// without a url). Reading `logo.secure_url` straight off it took the whole venue page down (#1333).
export const getVenueLogoUrl = (venue?: Pick<Venue, 'logo'> | null): string =>
  venue?.logo?.secure_url || DEFAULT_VENUE_IMAGE
